export const BODY_ID = 'RegistrationCardEditComplementary';
